import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, tap } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { LocationService } from '@core/jss-seo';
import { FehApiActions } from '@feh/shared-api';
import { getAppConfig } from '@core/config-store';
import { Router } from '@angular/router';

import { resetSubmitState, submitGeneralAdviceForm } from '../actions';
import { generalAdviceFormSelectorKey } from '../reducers';
import { selectGeneralAdviceRedirectUrl } from '../selectors';
import {
  mapFormToPostAdviceV1Data,
  mapFormToPostProductadviceV1Data,
} from './general-advice-effects-helpers';

@Injectable()
export class GeneralAdviceFormEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly location = inject(LocationService);
  private readonly router = inject(Router);
  private readonly config = this.store.selectSignal(getAppConfig);

  submitForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(submitGeneralAdviceForm),
      map(({ payload }) => {
        const brand =
          this.config()?.brand === 'ed' ? 'energiedirect' : 'essent';

        if (payload.scContext.productType === 'Advies') {
          return FehApiActions.postAdviceV1.requestAction({
            actionId: generalAdviceFormSelectorKey,
            payload: mapFormToPostAdviceV1Data(
              payload.formData,
              payload.scContext,
              brand,
              this.router.url,
              payload.e2eTrackingId
            ),
          });
        } else {
          return FehApiActions.postProductadviceV1.requestAction({
            actionId: generalAdviceFormSelectorKey,
            payload: mapFormToPostProductadviceV1Data(
              payload.formData,
              payload.scContext,
              brand,
              this.router.url,
              payload.e2eTrackingId
            ),
          });
        }
      })
    );
  });

  handleCreateLeadSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        FehApiActions.postAdviceV1.successAction,
        FehApiActions.postProductadviceV1.successAction
      ),
      filter((params) => params.actionId === generalAdviceFormSelectorKey),
      concatLatestFrom(() => [
        this.store.select(selectGeneralAdviceRedirectUrl),
      ]),
      tap(([_, redirectUrl]) => {
        this.location.navigateGeneralLink(redirectUrl?.value?.href as string);
      }),
      map(() => resetSubmitState())
    )
  );
}
